//export default class Team {
//   constructor() {
//     this.$sections = document.querySelectorAll('section.team');
//   }
//}
//
//new Team();

import Swiper, { Navigation } from "swiper";
// import Swiper and modules styles
import "swiper/css";
import "swiper/css/navigation";
import AOS from "aos";
import "aos/dist/aos.css";

document.addEventListener("DOMContentLoaded", () => {
  var TeamSwiper = new Swiper(".swiper-team", {
    // Optional parameters
    modules: [Navigation],
    direction: "horizontal",
    loop: true,

    // Navigation arrows
    navigation: {
      nextEl: ".swiper-team-next",
      prevEl: ".swiper-team-prev",
    },
  });

  AOS.init();

  document.querySelectorAll(".person").forEach((element) => {
    element.addEventListener("click", function () {
      var slide = element.dataset.slide;
      document.querySelector(".popup").style.display = "flex";
      TeamSwiper.slideTo(slide, false, false);
      document.querySelector("body").style.overflow = "hidden";
    });
  });
});

const popup = document.querySelector(".popup");
window.onclick = function (event) {
  if (event.target == popup) {
    popup.style.display = "none";
  }
};

document.querySelectorAll(".close-swiper").forEach(function (element) {
  element.addEventListener("click", () => {
    popup.style.display = "none";
    document.querySelector("body").style.overflow = "initial";
  });
});
